import {useDataSource} from "src/core/data-sources/decorators/withData";
import MarketingSourcesDataSource from "src/core/authentication/data-sources/marketingSources";

function useMarketingSources() {
  const {data: marketingSources} = useDataSource(
    {},
    {
      dataSource: marketingSourcesDataSource,
    }
  );

  return [marketingSources];
}

const marketingSourcesDataSource = new MarketingSourcesDataSource();

export default useMarketingSources;
